import { TextField, type TextFieldProps } from '@ui/atoms/text-field/textfield'
import React from 'react'

export const SearchField: React.FC<TextFieldProps> = (props) => (
  <TextField
    fullWidth
    className="flex-1"
    placeholder="Que recherchez-vous ?"
    size="small"
    inputProps={{
      tabIndex: 1,
    }}
    {...props}
  />
)
